import React from "react";
import LinearProgress from "@material-ui/core/LinearProgress";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import TitlePage from "../../app/Title/TitlePage/TitlePageView";
import {Button} from "primereact/button";
import Typography from "@material-ui/core/Typography";
import {Password} from "primereact/password";
import SubtitleLabel from "../../app/Title/SubtitleLabel/SubtitleLabelView";

const ChangePassword = ({
                            isLoading,
                            updateOldPassword,
                            updateNewPassword,
                            updateConfirmNewPassword,
                            handleReturnButton,
                            handleSaveButton,
                            ...props
                        }) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                <Grid container spacing={1}>
                <Grid item xs={6}>
                    <TitlePage title='Cambio de contraseña'/>
                </Grid>
                <Grid item xs={6} style={{textAlign: "right"}}>
                        {
                            localStorage.getItem("menu") !== null &&
                                <Button label="Cancelar" onClick={handleReturnButton} className="p-button-secondary"/>
                        }&nbsp;
                            <Button label="Guardar" onClick={handleSaveButton}/>

                </Grid>
                <Grid item xs={12}>
                    <div className="p-grid">
                        <div className="p-col-12">
                            <SubtitleLabel header="Contraseña Actual" isBold={true}/>
                            <Password value={props.oldPassword} feedback={false} onChange={updateOldPassword}
                                      maxLength={15}/>
                        </div>
                        <div className="p-col-12">
                            <SubtitleLabel header="Contraseña Nueva" isBold={true}/>
                            <Password value={props.newPassword} promptLabel={"Escriba su Contraseña"} weakLabel={'Baja'}
                                      mediumLabel={'Media'}
                                      strongLabel={'Alta'} onChange={updateNewPassword}
                                      maxLength={15}
                            />
                        </div>
                        <div className="p-col-12">
                            <SubtitleLabel header="Confirmación de Contraseña" isBold={true}/>
                            <Password
                                value={props.confirmNewPassword}
                                onChange={updateConfirmNewPassword}
                                feedback={false}
                                maxLength={15}
                            />
                        </div>
                        <div className="p-col-12">
                            <SubtitleLabel header="Política de Contraseña" isBold={true}/>
                            <Typography variant="subtitle2" gutterBottom className={"secondary-text"}>
                                Longitud mínima 12 caracteres.<br/>
                                Debe contener una mayúscula.<br/>
                                Debe contener una minúscula.<br/>
                                Debe contener un número.<br/>
                                Debe contener un caracter especial (!"#$%&/()=?@*\-.,{}+).<br/>
                                NO debe contener el usuario.<br/>
                                NO debe contener 2 números, letras o símbolos idénticos de manera consecutiva.
                            </Typography>
                        </div>
                    </div>
                </Grid>
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default (ChangePassword);